var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "30px",
    viewBox: "0 0 32 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.0_Cadastro-do-usuario---menu-aberto",
    transform: "translate(-54.000000, -351.000000)",
    fill: "#2B2B2B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(50.000000, 346.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 16,
    y: 9,
    width: 20,
    height: 1.3,
    rx: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 9,
    width: 6,
    height: 1.3,
    rx: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.15,5.4 C15.4419817,5.4 17.3,7.25801829 17.3,9.55 C17.3,11.8419817 15.4419817,13.7 13.15,13.7 C10.8580183,13.7 9,11.8419817 9,9.55 C9,7.25801829 10.8580183,5.4 13.15,5.4 Z M13.15,6.7 C11.5759885,6.7 10.3,7.97598846 10.3,9.55 C10.3,11.1240115 11.5759885,12.4 13.15,12.4 C14.7240115,12.4 16,11.1240115 16,9.55 C16,7.97598846 14.7240115,6.7 13.15,6.7 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 15.700000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 3.6,
    width: 20,
    height: 1.3,
    rx: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 26,
    y: 3.6,
    width: 6,
    height: 1.3,
    rx: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.15,1.0658141e-14 C25.4419817,1.0658141e-14 27.3,1.85801829 27.3,4.15 C27.3,6.44198171 25.4419817,8.3 23.15,8.3 C20.8580183,8.3 19,6.44198171 19,4.15 C19,1.85801829 20.8580183,1.0658141e-14 23.15,1.0658141e-14 Z M23.15,1.3 C21.5759885,1.3 20.3,2.57598846 20.3,4.15 C20.3,5.72401154 21.5759885,7 23.15,7 C24.7240115,7 26,5.72401154 26,4.15 C26,2.57598846 24.7240115,1.3 23.15,1.3 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 16,
    y: 30,
    width: 20,
    height: 1.3,
    rx: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 30,
    width: 6,
    height: 1.3,
    rx: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.15,26.4 C15.4419817,26.4 17.3,28.2580183 17.3,30.55 C17.3,32.8419817 15.4419817,34.7 13.15,34.7 C10.8580183,34.7 9,32.8419817 9,30.55 C9,28.2580183 10.8580183,26.4 13.15,26.4 Z M13.15,27.7 C11.5759885,27.7 10.3,28.9759885 10.3,30.55 C10.3,32.1240115 11.5759885,33.4 13.15,33.4 C14.7240115,33.4 16,32.1240115 16,30.55 C16,28.9759885 14.7240115,27.7 13.15,27.7 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.d4f32cadab958104746a0bc60d9d4555.svg";
export { ForwardRef as ReactComponent };